@if (showPendingAnalyticsMessage) {
  <p-panel>
    <ng-template pTemplate="header">
      <span class="p-panel-title">
        Thank you for the request.
      </span>
    </ng-template>
    <p>{{ analyticsMessage }}</p>
  </p-panel>
}

@if (!showPendingAnalyticsMessage) {
  <p-panel>
    <ng-template pTemplate="header">
      <span class="p-panel-title" data-test-id="complete-panel-header-title">
        The authorization request {{ authorizationNumber }} has been submitted.
        @if (isExternal) {
          <span>{{ isAutoApproved ? 'The request is complete.' : 'The authorization is pending for clinical review.' }}</span>
        }
      </span>
    </ng-template>
    @if (authorizationNumber) {
      <div>
        <span class="complete-message" data-test-id="auth-number-available-message">
          The authorization request has been submitted. Click a button below to view
          {{ showRedirectToAuthPage ? 'the authorization request' : 'Member Details'}} or return to Home Page.
        </span>
      </div>
    } @else {
      <span data-test-id="auth-number-unavailable-message">
        Click a button below to return to Member Details, the Homepage, or Print a copy of your request.
      </span>
    }
  </p-panel>
}

@if (!isPASCompleteFlow) {
  <div class="flex justify-end mt-4">
    <button
      pButton
      aria-label="Return to Home Page"
      label="Return to Home Page"
      icon="pi pi-home"
      type="button"
      data-test-id="home-navigate-button"
      (click)="navigateToHome.emit()"
      [class]="showPendingAnalyticsMessage ? 'p-button-primary' : 'p-button-outlined mr-2'"
    ></button>
    @if (!showPendingAnalyticsMessage) {
      <div>
        @if (showRedirectToAuthPage) {
          <div>
            <button
              pButton
              aria-label="View Authorization Request"
              label="View Authorization Request"
              icon="pi pi-user"
              severity="secondary"
              type="button"
              data-test-id="view-auth-request-button"
              (click)="navigateToAuthorization.emit()"
            ></button>
          </div>
        } @else {
          <button
            pButton
            aria-label="Return to Member Details"
            label="Return to Member Details"
            icon="pi pi-user"
            severity="secondary"
            type="button"
            data-test-id="member-navigate-button"
            (click)="navigateToMember.emit()"
          ></button>
        }
      </div>
    }
  </div>
} @else {
  <div class="flex justify-end mt-4">
    <button
      pButton
      aria-label="Return to Home Page"
      label="Return to Home Page"
      icon="pi pi-home"
      severity="secondary"
      class="mr-2"
      type="button"
      data-test-id="home-navigate-button"
      (click)="navigateToHome.emit()"
    ></button>
    <button
      pButton
      aria-label="Return to Original Request"
      label="Return to Original Request"
      icon="pi pi-file"
      severity="secondary"
      class="mr-2"
      type="button"
      data-test-id="view-original-auth-request-button"
      (click)="navigateToOriginLoPACAuth.emit()"
    ></button>
    <button
      pButton
      aria-label="View New Request"
      label="View New Request"
      icon="pi pi-file"
      class="p-button-primary"
      type="button"
      data-test-id="view-auth-request-button"
      (click)="navigateToAuthorization.emit()"
    ></button>
  </div>
}

